import { Image, Linking, StyleSheet, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

import ParentScrollView from "components/ParentScrollView";
import Images from "assets/index";
import VText from "components/VText";
import Heading from "components/Heading";
export default function ReturnsAndExchanges() {
    return (
        <ParentScrollView>
            <View style={styles.container}>
                <View style={{ ...styles.aboutTextContainer, alignItems: "center" }}>
                    <Heading type="h1" style={styles.aboutHeadingText}>Returns & Exchanges Policy</Heading>
                </View>

                <View style={{ ...styles.aboutTextContainer, marginTop: spV(20) }}>
                    <VText style={styles.paragraphText}>
                        Vêtir partners with a diverse range of luxury retailers and brands to offer you an extensive
                        selection of products. As such, return and exchange policies may vary depending on the brand or
                        retailer from which your order was shipped. Please refer to the product page for each brand or
                        retailer partners’ individual return policies. For any questions, reach out to our client
                        support team at{" "}
                        <VText
                            style={{ ...styles.aboutHeadingSubText, fontWeight: "500" }}
                            onPress={() => Linking.openURL("mailto:concierge@vetirapp.com")}
                        >
                            Concierge@vetirapp.com
                        </VText>
                        .
                    </VText>
                    <Image
                        accessibilityLabel="Returns and Exchanges Image"
                        source={require("assets/returnAndRefund.webp")}
                        alt="returns-and-exchanges"
                        style={{ width: "auto", height: hp(300), marginBottom: spV(20) }}
                    />

                    <Heading type="h2" style={styles.paragraphHeading}>Return Eligibility:</Heading>
                    <VText style={styles.paragraphText}>
                        To initiate a return or exchange, please follow the return instructions provided by the brand or
                        retailer that fulfilled your order. Each brand or retailer has its own return process. Some may
                        offer free returns, while others may require you to cover shipping costs. Occasionally, a brand
                        or retailer may include a prepaid return shipping label in the box with your order, making
                        returns more convenient. Our team will guide you through the necessary steps and provide you
                        with a return label where applicable.
                        <VText style={{ ...styles.aboutHeadingSubText }}>
                            {" "}
                            Please note that returns and refunds are not eligible on final sale items.
                        </VText>
                    </VText>

                    <Heading type="h2" style={styles.paragraphHeading}>Initiating a Return:</Heading>
                    <VText style={styles.paragraphText}>
                        To initiate a return or exchange, please follow the return instructions provided by the brand or
                        retailer that fulfilled your order. Each brand or retailer has its own return process. Some may
                        offer free returns, while others may require you to cover shipping costs. Occasionally, a brand
                        or retailer may include a prepaid return shipping label in the box with your order, making
                        returns more convenient. Our team will guide you through the necessary steps and provide you
                        with a return label where applicable.
                    </VText>

                    <VText style={styles.paragraphText}>
                        Alternatively, if you need assistance with a return label, you can email us at{" "}
                        <VText
                            style={{ ...styles.aboutHeadingSubText }}
                            onPress={() => Linking.openURL("mailto:concierge@vetirapp.com")}
                        >
                            Concierge@vetirapp.com
                        </VText>{" "}
                        to initiate the process. Be sure to include:
                    </VText>
                    <View style={styles.listContainer}>
                        <VText style={styles.listItem}>• Order number</VText>
                        <VText style={styles.listItem}>• First & last name</VText>
                        <VText style={styles.listItem}>• Date of purchase</VText>
                        <VText style={styles.listItem}>• Reason for the return</VText>
                        <VText style={styles.listItem}>• Name of the item(s) you are returning</VText>
                    </View>

                    <Heading type="h2" style={styles.paragraphHeading}>Cancellations:</Heading>
                    <VText style={styles.paragraphText}>
                        Once your order is finalized, we generally cannot accommodate modifications or cancellations. If
                        your order has not yet shipped, there may be a possibility to make changes—please check your
                        confirmation email for details as this varies by vendor. However, once an order has been
                        dispatched, it cannot be altered or canceled. In such cases, our support team is here to help
                        you initiate a return. Please note that items labeled as Final Sale are not eligible for
                        returns. If you need assistance with order changes or cancellations, please reach out to our
                        support team at{" "}
                        <VText
                            style={{ ...styles.aboutHeadingSubText }}
                            onPress={() => Linking.openURL("mailto:concierge@vetirapp.com")}
                        >
                            {" "}
                            Concierge@vetirapp.com
                        </VText>
                        .
                    </VText>
                    <VText style={styles.paragraphText}>
                        <Heading type="h2" style={styles.aboutHeadingSubText}>Shipping Costs: </Heading>
                        Return shipping fees may vary based on the policy of the brand or retailer. We recommend
                        reviewing the specific return conditions applicable to your item on the original brand or
                        retailer's website.
                    </VText>
                    <VText style={styles.paragraphText}>
                        When shipping your item for return, ensure the item and its original packaging are fully sealed
                        to prevent damage during transit. Vêtir is not responsible for items damaged or lost in return
                        transit.
                    </VText>

                    <VText style={styles.paragraphText}>
                        <Heading type="h2" style={styles.aboutHeadingSubText}>Refunds: </Heading>
                        Refunds will be processed within 3-14 business days after the returned item is received and
                        inspected by the originating brand or retailer. Refunds will be issued to the original form of
                        payment. Please note that the time it takes to receive your refund may vary.
                    </VText>
                    <VText style={styles.paragraphText}>
                        <Heading type="h2" style={styles.aboutHeadingSubText}>Exchanges: </Heading>
                        Some brands may offer exchanges, while others may require you to return the item and place a new
                        order. Please follow the specific exchange instructions from the brand or retailer associated
                        with your purchase.
                    </VText>

                    <VText style={styles.paragraphText}>
                        <Heading type="h2" style={styles.aboutHeadingSubText}>International Returns: </Heading>
                        If you are returning an international order, please be aware that customs duties and taxes may
                        apply. Review the international return policy of the brand or retailer for further details.
                    </VText>

                    <VText style={styles.paragraphText}>
                        <Heading type="h2" style={styles.aboutHeadingSubText}>Taxes and Duties: </Heading>
                        For U.S. orders, Vêtir does not collect sales tax in all states, but your purchase may still be
                        subject to sales or use tax. Depending on your shipping location, you may be exempt from sales
                        tax, while some states may require you to report and pay tax on online purchases when filing
                        your annual tax return.
                    </VText>

                    <VText style={styles.paragraphText}>
                        For international orders, additional duties and taxes may apply depending on the destination
                        country. These fees are the responsibility of the customer and will be calculated at checkout or
                        billed upon delivery, as required by local customs authorities.
                    </VText>

                    <VText style={styles.paragraphText}>
                        <Heading type="h2" style={styles.aboutHeadingSubText}>Note: </Heading>
                        If you believe an item to be defective, damaged, or incorrect, please contact our client support
                        immediately at{" "}
                        <VText
                            style={{ ...styles.aboutHeadingSubText }}
                            onPress={() => Linking.openURL("mailto:concierge@vetirapp.com")}
                        >
                            Concierge@vetirapp.com
                        </VText>{" "}
                        so that we can help resolve the issue.
                    </VText>
                    <VText style={styles.paragraphText}>
                        For any additional questions or concerns regarding your return or exchange, please contact our
                        client support team at{" "}
                        <VText
                            style={{ ...styles.aboutHeadingSubText }}
                            onPress={() => Linking.openURL("mailto:concierge@vetirapp.com")}
                        >
                            Concierge@vetirapp.com
                        </VText>
                        .
                    </VText>
                </View>
            </View>
        </ParentScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        paddingBottom: spV(20),
        width: "auto",
        marginTop: spV(32),
    },

    paragraphText: {
        fontSize: fp(16),
        fontWeight: "300",
        lineHeight: 25,
        textAlign: "left",
        marginBottom: spV(10),
    },
    paragraphHeading: {
        fontSize: fp(20),
        fontWeight: "350",
        textAlign: "left",
        marginBottom: spV(8),
        marginTop: spV(10),
    },

    aboutTextContainer: {
        alignItems: "left",
        // marginTop: spV(60),
        marginLeft: spH(140),
        marginRight: spH(140),
    },
    aboutHeadingText: {
        textAlign: "center",
        fontSize: fp(28),
        fontFamily: "LibreBodoni",
        fontWeight: "350",
    },
    aboutHeadingSubText: {
        fontWeight: "350",
    },

    aboutSubText: {
        marginTop: spV(30),
        fontSize: fp(18),
        fontWeight: "350",
        lineHeight: 33,
        textAlign: "left",
    },
    listContainer: {
        marginLeft: spH(20),
    },
    listItem: {
        fontSize: fp(16),
        fontWeight: "300",
        marginBottom: spV(4),
    },
});
